require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-allie-grampa.json") })
        }
      }, "path---blog-author-allie-grampa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-allie-grampa!./.cache/json/blog-author-allie-grampa.json
// module id = 598
// module chunks = 231608221292675